module.exports = __webpack_public_path__ + "static/img/1@2x.737e0b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile/1@2x.png
// module id = 3D8d
// module chunks = 1